import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from './utils/i18n'
import store from "./store";
// import request from "../src/api/request";
import "../public/css/common.less";
import vant from "../src/utils/vant"; //按需引入vant
import "vant/lib/index.less";
import "lib-flexible"; //引入postcss-px2rem插件
import { Dialog } from "vant"; //Dialog组件使用全局引入的方式调用
import { Swipe, SwipeItem, Lazyload, Icon } from "vant"; // 轮播图插件
import VideoPlayer from "vue-video-player"; // 视频播放插件
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
import { Image as VanImage } from "vant";
import { getCookie } from "./utils/cookies";
import { getStore } from "./utils/storage";

Vue.config.productionTip = false;
import VueScroller from "vue-scroller";
Vue.use(VueScroller);
Vue.config.productionTip = false;
Vue.use(vant);
Vue.use(Dialog);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Lazyload);
Vue.use(Icon);
Vue.use(VideoPlayer);
Vue.use(VanImage);

// 如果缓存中有用户的登录信息则同步更新vuex获取权限
if (getCookie("token")) {
  const res = {
    user: getStore("user") || ""
    // router: router
  };
  store.dispatch("setUser", res); //存入登陆信息对象
}

// console.log(123,Vue)

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
